import { PLATFORM } from 'aurelia-pal';

import { SESSION_EVENTS } from 'libs/oac/constants/sessionEvents.constant';
import { AppConfiguration } from 'libs/oac/services/appConfiguration.service';
import { AppErrorHandler } from 'libs/oac/services/appErrorHandler.service';
import { AppLogger } from 'libs/oac/services/appLogger.service';
import { AppRequestsCache } from 'libs/oac/services/appRequestsCache.service';
import { AppRouting } from 'libs/oac/services/appRouting.service';
import { AppSession } from 'libs/oac/services/appSession.service';
import { AppSessionCapabilities } from 'libs/oac/services/appSessionCapabilities.service';
import { AppUtils } from 'libs/oac/services/appUtils.service';
import { AppRoutingStep } from 'libs/oac/steps/appRouting.step';

const menuContainer = PLATFORM.moduleName('libs/oac/containers/menu/menu.container');

export const configure = (aurelia, options) => {
  // Constants
  aurelia.container.registerInstance('SESSION_EVENTS', SESSION_EVENTS);

  // Services
  aurelia.container.registerSingleton('appConfiguration', AppConfiguration);
  aurelia.container.registerSingleton('appErrorHandler', AppErrorHandler);
  aurelia.container.registerSingleton('appLogger', AppLogger);
  aurelia.container.registerSingleton('appRequestsCache', AppRequestsCache);
  aurelia.container.registerSingleton('appRouting', AppRouting);
  aurelia.container.registerSingleton('appSession', AppSession);
  aurelia.container.registerSingleton('appSessionCapabilities', AppSessionCapabilities);
  aurelia.container.registerSingleton('appUtils', AppUtils);

  // Steps
  aurelia.container.registerInstance('appRoutingStep', AppRoutingStep);

  aurelia.globalResources(menuContainer);

  // Configuration setup
  const appConfiguration = aurelia.container.get('appConfiguration');
  appConfiguration.setConfig(options.configuration);
};
